import { useSimulationId } from '../../GanttSimulation/hooks';

export const getInstanceId = (simulationId?: number): string => (simulationId ? `simulation-${simulationId}` : 'gantt');

export const useGanttInstanceId = () => {
  const { id: simulationId } = useSimulationId();
  return getInstanceId(simulationId);
};
